const doc = [({"da":({"js":({"admin":({"photos":({"canvas":({"the_photo_was_deleted":"Fotoet blev slettet."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;